const passwordFieldsWithPasswordStrength: NodeListOf<HTMLDivElement> =
  document.querySelectorAll("div[data-password-strength]");

// Hardcoded password strength rules
passwordFieldsWithPasswordStrength.forEach((passwordField) => {
  const passwordInput: HTMLInputElement | null = passwordField.querySelector(
    'input[type="password"]',
  );
  const passwordRules: HTMLDivElement | null = passwordField.querySelector(
    "[data-password-rules]",
  );

  if (!passwordInput || !passwordRules) return;

  // Password rules elements
  const passwordLength: HTMLLIElement | null =
    passwordRules.querySelector("[data-rule-length]");
  const passwordLowerChars: HTMLLIElement | null = passwordRules.querySelector(
    "[data-rule-lower-chars]",
  );
  const passwordUpperChars: HTMLLIElement | null = passwordRules.querySelector(
    "[data-rule-upper-chars]",
  );
  const passwordNumbers: HTMLLIElement | null = passwordRules.querySelector(
    "[data-rule-numbers]",
  );
  const passwordSpecialChars: HTMLLIElement | null =
    passwordRules.querySelector("[data-rule-special-chars]");

  if (
    !passwordLength ||
    !passwordLowerChars ||
    !passwordUpperChars ||
    !passwordNumbers ||
    !passwordSpecialChars
  ) {
    return console.error("Missing password rules elements in the template.");
  }

  passwordInput.setAttribute("valid", "false");

  passwordInput.addEventListener("input", () => {
    // Make the password rules visible
    passwordRules.setAttribute("data-password-rules-visible", "");

    const password: string = passwordInput.value;

    const passwordLengthValid: boolean = /^.{8,}$/.test(password);
    const passwordLowerCharsValid: boolean = /[a-z]/.test(password);
    const passwordUpperCharsValid: boolean = /[A-Z]/.test(password);
    const passwordNumbersValid: boolean = /\d/.test(password);
    const passwordSpecialCharsValid: boolean = /[\W_]/.test(password);

    if (passwordLengthValid) {
      passwordLength.classList.add("valid");
      passwordLength.classList.remove("not-valid");
    } else {
      passwordLength.classList.remove("valid");
      passwordLength.classList.add("not-valid");
    }

    if (passwordLowerCharsValid) {
      passwordLowerChars.classList.add("valid");
      passwordLowerChars.classList.remove("not-valid");
    } else {
      passwordLowerChars.classList.remove("valid");
      passwordLowerChars.classList.add("not-valid");
    }

    if (passwordUpperCharsValid) {
      passwordUpperChars.classList.add("valid");
      passwordUpperChars.classList.remove("not-valid");
    } else {
      passwordUpperChars.classList.remove("valid");
      passwordUpperChars.classList.add("not-valid");
    }

    if (passwordNumbersValid) {
      passwordNumbers.classList.add("valid");
      passwordNumbers.classList.remove("not-valid");
    } else {
      passwordNumbers.classList.remove("valid");
      passwordNumbers.classList.add("not-valid");
    }

    if (passwordSpecialCharsValid) {
      passwordSpecialChars.classList.add("valid");
      passwordSpecialChars.classList.remove("not-valid");
    } else {
      passwordSpecialChars.classList.remove("valid");
      passwordSpecialChars.classList.add("not-valid");
    }

    if (
      passwordLengthValid &&
      passwordLowerCharsValid &&
      passwordUpperCharsValid &&
      passwordNumbersValid &&
      passwordSpecialCharsValid
    ) {
      passwordInput.setAttribute("valid", "true");
    } else {
      passwordInput.setAttribute("valid", "false");
    }
  });
});
